import chartBuilderBase from "./chartBuilderBase.js";
import chartDisplaySettings from "./chartDisplaySettings.js";

/**
 * Builds default yAxis options http://api.highcharts.com/highcharts#yAxis
 *
 * @param {object} spec - Parameter object
 * @param {object} my - protected fields holder
 * @return {{}}
 */
function yAxisBuilder(spec, my) {
	spec ||= {};
	my ||= {};

	const builderSpec = Object.create(spec);

	builderSpec.options = chartBuilderBase.mergeOptions(
		builderSpec.options || {},
		{
			lineWidth: 0,
			minorGridLineWidth: 0,
			labels: {
				enabled: false,
			},
			title: null,
			minorTickLength: 0,
			tickLength: 0,
			gridLineWidth: 0,

			// Show line for y = 0
			plotLines: [
				{
					color: chartDisplaySettings.chartBackgroundColor,
					width: 1,
					value: 0,
				},
			],
		},
	);

	const that = chartBuilderBase(builderSpec, my);
	my.myself = that;

	return that;
}

export default yAxisBuilder;
